import { useEffect, useState } from 'react';
import { IDiner } from 'src/utilities/useSearchHooks';
import { sdk } from 'src/utilities/sdk';
import { pushErrorFromAPI } from 'src/utilities/notifications';

export type UseGetParentAdminsReturn = {
  diner: IDiner | undefined;
};

export const useGetAdminById = (
  corpId: string,
  dinerId: string
): UseGetParentAdminsReturn => {
  const [diner, setDiner] = useState<IDiner>();

  useEffect(() => {
    (async () => {
      try {
        const response = await sdk.http.get(
          `/corp-admin/${corpId}/diners/${dinerId}`
        );
        setDiner(response);
      } catch (error) {
        pushErrorFromAPI(error, {
          fallbackMessage:
            'There was a problem retrieving the admin data. Try again.',
        });
      }
    })();
  }, [corpId, dinerId]);

  return { diner };
};
